module.exports = __webpack_public_path__ + "static/media/arrow-ddl-dark.beef9e31.svg";